// extracted by mini-css-extract-plugin
export default {"root":"DraggableVTabs_root__nB0IT"};